import "./NewCustomers.scss";
import { CloseIcon, BusinessIcon, UserIcon, MapPinIcon, StarIcon, MailIcon, PhoneIcon } from "../../../../../shared/margincalculator/components/icons/Icon";
import { useState, type ChangeEvent } from "react";

interface NewCustomersProps {
  onClose: () => void;
}

type TabType = "firma" | "person" | "adresse" | "optionen";

function NewCustomers({ onClose }: NewCustomersProps) {
  const [activeTab, setActiveTab] = useState<TabType>("firma");
  const [person, setPerson] = useState({
    anrede: "",
    vorname: "",
    nachname: "",
    ansprechpartnerAlt: "",
    geburtstag: "",
    email: "",
    telefon: "",
    festnetz: "",
    handy: "",
  });
  const [address, setAddress] = useState({
    strasse: "",
    nummer: "",
    plz: "",
    ort: "",
  });
  const [options, setOptions] = useState({
    kundenstatus: "Aktiv",
    vip: false,
    emailMarketing: false,
    smsMarketing: false,
    postMarketing: false,
  });

  const updatePerson = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = event.target;
    setPerson((current) => ({ ...current, [name]: value }));
  };

  const updateAddress = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setAddress((current) => ({ ...current, [name]: value }));
  };

  const updateOption = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setOptions((current) => ({ ...current, [name]: checked }));
  };

  return (
    <div className="new-customer-overlay" onClick={onClose}>
      <div
        className={`new-customer-modal ${activeTab !== "firma" ? "new-customer-modal--details" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="new-customer-modal__close" onClick={onClose}>
          <CloseIcon />
        </button>

        <header className="new-customer-modal__header">
          <h2>Neuen Kunden anlegen</h2>
          <p>
            Füllen Sie die Kundendaten aus. Nur der Firmenname ist erforderlich.
          </p>
        </header>

        <nav className="new-customer-modal__tabs">
          <button
            className={`new-customer-modal__tab ${activeTab === "firma" ? "new-customer-modal__tab--active" : ""}`}
            onClick={() => setActiveTab("firma")}
          >
            <BusinessIcon /> Firma
          </button>
          <button
            className={`new-customer-modal__tab ${activeTab === "person" ? "new-customer-modal__tab--active" : ""}`}
            onClick={() => setActiveTab("person")}
          >
            <UserIcon /> Person
          </button>
          <button
            className={`new-customer-modal__tab ${activeTab === "adresse" ? "new-customer-modal__tab--active" : ""}`}
            onClick={() => setActiveTab("adresse")}
          >
            <MapPinIcon /> Adresse
          </button>
          <button
            className={`new-customer-modal__tab ${activeTab === "optionen" ? "new-customer-modal__tab--active" : ""}`}
            onClick={() => setActiveTab("optionen")}
          >
            <StarIcon /> Optionen
          </button>
        </nav>

        <div className="new-customer-modal__content">
          {activeTab === "firma" && (
            <>
              <div className="new-customer-modal__form-group">
                <label>Firmenname *</label>
                <input type="text" placeholder="Muster GmbH" />
              </div>
              <div className="new-customer-modal__form-group">
                <label>Branche</label>
                <input type="text" placeholder="IT & Telekommunikation" />
              </div>
              <div className="new-customer-modal__form-group">
                <label>Notizen</label>
                <textarea placeholder="Interne Notizen zum Kunden..."></textarea>
              </div>
            </>
          )}

          {activeTab === "person" && (
            <div className="new-customer-modal__person-grid">
              <div className="new-customer-modal__form-group">
                <label htmlFor="customer-anrede">Anrede</label>
                <select id="customer-anrede" name="anrede" value={person.anrede} onChange={updatePerson}>
                  <option value="">Auswählen</option>
                  <option value="Herr">Herr</option>
                  <option value="Frau">Frau</option>
                  <option value="Divers">Divers</option>
                </select>
              </div>
              <div className="new-customer-modal__form-group">
                <label htmlFor="customer-vorname">Vorname</label>
                <input id="customer-vorname" name="vorname" type="text" autoComplete="given-name" placeholder="Max" value={person.vorname} onChange={updatePerson} />
              </div>
              <div className="new-customer-modal__form-group">
                <label htmlFor="customer-nachname">Nachname</label>
                <input id="customer-nachname" name="nachname" type="text" autoComplete="family-name" placeholder="Mustermann" value={person.nachname} onChange={updatePerson} />
              </div>
              <div className="new-customer-modal__form-group new-customer-modal__person-full">
                <label htmlFor="customer-ansprechpartner">Ansprechpartner (alt)</label>
                <input id="customer-ansprechpartner" name="ansprechpartnerAlt" type="text" placeholder="Für Legacy-Daten" value={person.ansprechpartnerAlt} onChange={updatePerson} />
              </div>
              <div className="new-customer-modal__form-group new-customer-modal__person-full">
                <label htmlFor="customer-geburtstag">Geburtstag</label>
                <input id="customer-geburtstag" name="geburtstag" type="date" value={person.geburtstag} onChange={updatePerson} />
              </div>
              <div className="new-customer-modal__person-contact">
                <div className="new-customer-modal__form-group">
                  <label htmlFor="customer-email"><MailIcon /> E-Mail</label>
                  <input id="customer-email" name="email" type="email" autoComplete="email" placeholder="kontakt@muster.de" value={person.email} onChange={updatePerson} />
                </div>
                <div className="new-customer-modal__form-group">
                  <label htmlFor="customer-telefon"><PhoneIcon /> Telefon (Haupt)</label>
                  <input id="customer-telefon" name="telefon" type="tel" autoComplete="tel" placeholder="+49 123 456789" value={person.telefon} onChange={updatePerson} />
                </div>
                <div className="new-customer-modal__form-group">
                  <label htmlFor="customer-festnetz">Festnetz</label>
                  <input id="customer-festnetz" name="festnetz" type="tel" placeholder="+49 30 123456" value={person.festnetz} onChange={updatePerson} />
                </div>
                <div className="new-customer-modal__form-group">
                  <label htmlFor="customer-handy">Handy</label>
                  <input id="customer-handy" name="handy" type="tel" placeholder="+49 170 1234567" value={person.handy} onChange={updatePerson} />
                </div>
              </div>
            </div>
          )}

          {activeTab === "adresse" && (
            <div className="new-customer-modal__address-grid">
              <div className="new-customer-modal__form-group new-customer-modal__address-street">
                <label htmlFor="customer-strasse">Straße</label>
                <input id="customer-strasse" name="strasse" type="text" placeholder="Musterstraße" value={address.strasse} onChange={updateAddress} />
              </div>
              <div className="new-customer-modal__form-group new-customer-modal__address-number">
                <label htmlFor="customer-nummer">Nr.</label>
                <input id="customer-nummer" name="nummer" type="text" placeholder="123" value={address.nummer} onChange={updateAddress} />
              </div>
              <div className="new-customer-modal__form-group new-customer-modal__address-postcode">
                <label htmlFor="customer-plz">PLZ</label>
                <input id="customer-plz" name="plz" type="text" inputMode="numeric" autoComplete="postal-code" placeholder="12345" value={address.plz} onChange={updateAddress} />
              </div>
              <div className="new-customer-modal__form-group new-customer-modal__address-city">
                <label htmlFor="customer-ort">Ort</label>
                <input id="customer-ort" name="ort" type="text" autoComplete="address-level2" placeholder="Musterstadt" value={address.ort} onChange={updateAddress} />
              </div>
            </div>
          )}

          {activeTab === "optionen" && (
            <div className="new-customer-modal__options">
              <div className="new-customer-modal__form-group">
                <label htmlFor="customer-status">Kundenstatus</label>
                <select
                  id="customer-status"
                  value={options.kundenstatus}
                  onChange={(event) => setOptions((current) => ({ ...current, kundenstatus: event.target.value }))}
                >
                  <option value="Aktiv">Aktiv</option>
                  <option value="Inaktiv">Inaktiv</option>
                </select>
              </div>

              <label className="new-customer-modal__toggle new-customer-modal__toggle--vip">
                <span className="new-customer-modal__toggle-text">
                  <span className="new-customer-modal__toggle-title"><StarIcon /> VIP-Kunde</span>
                  <span className="new-customer-modal__toggle-description">Markiert Kunden für Sonderkonditionen</span>
                </span>
                <input type="checkbox" name="vip" checked={options.vip} onChange={updateOption} />
              </label>

              <fieldset className="new-customer-modal__marketing">
                <legend>Marketing-Einwilligungen</legend>
                <div className="new-customer-modal__marketing-list">
                  <label className="new-customer-modal__toggle">
                    <span className="new-customer-modal__toggle-text">
                      <span className="new-customer-modal__toggle-title">E-Mail Marketing</span>
                      <span className="new-customer-modal__toggle-description">Newsletter &amp; Angebote per E-Mail</span>
                    </span>
                    <input type="checkbox" name="emailMarketing" checked={options.emailMarketing} onChange={updateOption} />
                  </label>
                  <label className="new-customer-modal__toggle">
                    <span className="new-customer-modal__toggle-text">
                      <span className="new-customer-modal__toggle-title">SMS Marketing</span>
                      <span className="new-customer-modal__toggle-description">Angebote per SMS</span>
                    </span>
                    <input type="checkbox" name="smsMarketing" checked={options.smsMarketing} onChange={updateOption} />
                  </label>
                  <label className="new-customer-modal__toggle">
                    <span className="new-customer-modal__toggle-text">
                      <span className="new-customer-modal__toggle-title">Post Marketing</span>
                      <span className="new-customer-modal__toggle-description">Werbung per Brief</span>
                    </span>
                    <input type="checkbox" name="postMarketing" checked={options.postMarketing} onChange={updateOption} />
                  </label>
                </div>
              </fieldset>
            </div>
          )}
        </div>

        <footer className="new-customer-modal__footer">
          <button
            className="new-customer-modal__btn new-customer-modal__btn--cancel"
            onClick={onClose}
          >
            Abbrechen
          </button>
          <button className="new-customer-modal__btn new-customer-modal__btn--submit">
            Erstellen
          </button>
        </footer>
      </div>
    </div>
  );
}

export default NewCustomers;
